import { useState, useEffect } from "react";

const useAppleDevice = () => {
    const [isAppleDevice, setIsAppleDevice] = useState<boolean>(false);

    useEffect(() => {
        if (typeof window !== "undefined" && typeof navigator !== "undefined") {
            setIsAppleDevice(/Macintosh|iPhone|iPad|iPod/i.test(navigator.userAgent));
        }
    }, []);

    return isAppleDevice;
};

export default useAppleDevice;
